export default __webpack_public_path__ + "static/media/brand_small.22886060.svg";